export default theme => ({
  cardTitle: {
    color: theme.palette.primary['main'],
    textAlign: 'center',
    fontSize: "0.9em",
    fontWeight: 300

  },

  cardTitleBold: {
    color: theme.palette.primary['main'],
    textAlign: 'center',
    fontSize: "1.1em",
    fontWeight: 400
  },

  paymentMeanLogo: {
    padding: '20px 0px',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    height:'100px'
  },

  cardInstructions: {
    marginTop: '15px',
    color: theme.palette.grey['400']
  },

  cardInstruction: {
    color: theme.palette.grey['400'],
    marginBottom:'0.52em',
    lineHeight: '1.45em'
  },

  feedbackCard: {
    height: '380px',
    marginBottom: '20px',
    marginTop: '20px',
    boxShadow: '1px 1px 11px 2px rgba(0,0,0,0.056);'
  }
})
